import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { uploadImagecertifates } from "../../../Redux/Actions/Action";
import axios from "axios";
import toast from "react-hot-toast";
import { IoIosCloseCircle } from "react-icons/io";
import imgforbanner from "../../../assets/images/product/imgforbanner.png";
import { useParams, useNavigate } from "react-router-dom";

function AddMobileBanner() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams(); // get id from route

  const [title, setTitle] = useState("");
  const [image, setImage] = useState(null);
  const [webURL, setWebURL] = useState("");
  const [loading, setLoading] = useState(false);

  // ✅ Prefill for edit mode
  useEffect(() => {
    if (!id) return; // only fetch if editing

    const fetchBanner = async () => {
      try {
        const token = localStorage.getItem("vedhvidhi-admin-token");
        const res = await axios.get(
          `${process.env.REACT_APP_BASEURL}/admin/banner/hero/forMobileView/${id}`,
          { headers: { Authorization: token } }
        );

        if (res.data.success) {
          const data = res.data.data;
          setTitle(data.bannerTitle || "");
          setImage(data.imageUrl || null);
          setWebURL(data.redirectionUrl || "");
        }
      } catch (err) {
        console.error("Error fetching banner:", err);
        toast.error("Failed to fetch banner details");
      }
    };

    fetchBanner();
  }, [id]);

  // Handle image upload
  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setLoading(true);
    try {
      const uploadedImageUrl = await dispatch(uploadImagecertifates(file));
      setImage(uploadedImageUrl);
      toast.success("Image uploaded successfully!");
    } catch (error) {
      console.error("Upload error:", error);
      toast.error("Failed to upload image");
    }
    setLoading(false);
  };

  // Remove uploaded image
  const handleRemoveImage = () => setImage(null);

  // Save or Update banner
  const handleSave = async () => {
    if (!title || !image || !webURL) {
      toast.error("Please fill all required fields");
      return;
    }

    try {
      setLoading(true);
      const token = localStorage.getItem("vedhvidhi-admin-token");
      let response;

      if (id) {
      
        const payload = {
          bannerType: "forMobileView",
          imageId: id, 
          bannerTitle: title,
          imageUrl: image,
          redirectionUrl: webURL,
        };

        response = await axios.patch(
          `${process.env.REACT_APP_BASEURL}/admin/banner/hero`,
          payload,
          { headers: { Authorization: token, "Content-Type": "application/json" } }
        );
      } else {
        // ✅ Add new banner (POST)
        const payload = {
          heroBanners: [
            {
              bannerTitle: title,
              imageUrl: image,
              redirectionUrl: webURL,
            },
          ],
          bannerType: "forMobileView",
        };

        response = await axios.post(
          `${process.env.REACT_APP_BASEURL}/admin/banner`,
          payload,
          { headers: { Authorization: token, "Content-Type": "application/json" } }
        );
      }

      if (response.data.success) {
        toast.success(id ? "Mobile banner updated!" : "Mobile banner added!");
        navigate("/top-banners"); // redirect after save
      } else {
        toast.error("Failed to save banner");
      }
    } catch (error) {
      console.error("Error:", error.response?.data || error);
      toast.error(error.response?.data?.message || "Error saving banner");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        onClick={() => window.history.back()}
        style={{
          marginBottom: "10px",
          backgroundColor: "transparent",
          border: "none",
          cursor: "pointer",
          fontFamily: "monospace",
          fontSize: "18px",
          color: "#007bff",
          display: "flex",
          alignItems: "center",
          position: "relative",
          padding: "10px 20px",
        }}
      >
        <span style={{ marginRight: "8px" }}>&lt;</span>
        <span style={{ position: "relative", display: "inline-block" }}>
          Back
          <span
            style={{
              content: "''",
              position: "absolute",
              left: 0,
              bottom: -2,
              width: "100%",
              height: "1px",
              borderBottom: "2px solid #007bff",
            }}
          ></span>
        </span>
      </button>

      <div className="card">
        <div className="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
          <h6 className="mb-0 fw-bold">
            {id ? "Edit Mobile Banner" : "Add Mobile Banner"}
          </h6>
        </div>

        <div className="card-body">
          <form>
            {/* Banner Title */}
            <div className="mb-3">
              <label className="form-label fw-bold">Banner Title</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter banner title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
              />
            </div>

            {/* Banner Image */}
            <div className="mb-3">
              <label className="form-label fw-bold">Banner Image</label>
              <input
                type="file"
                accept=".jpg,.jpeg,.png,.webp"
                className="form-control"
                onChange={handleImageUpload}
              />
              <div className="mt-3">
                {image ? (
                  <div className="position-relative d-inline-block">
                    <img
                      src={image}
                      alt="uploaded"
                      style={{
                        width: "200px",
                        height: "100px",
                        objectFit: "cover",
                        borderRadius: "10px",
                        border: "1px solid #ccc",
                      }}
                    />
                    <button
                      type="button"
                      className="btn btn-sm bg-transparent border-0 position-absolute top-0 end-0"
                      onClick={handleRemoveImage}
                    >
                      <IoIosCloseCircle size={26} color="#727070" />
                    </button>
                  </div>
                ) : (
                  <img
                    src={imgforbanner}
                    alt="default"
                    style={{
                      width: "200px",
                      height: "100px",
                      objectFit: "cover",
                    }}
                  />
                )}
              </div>
            </div>

            {/* Banner URL */}
            <div className="mb-3">
              <label className="form-label fw-bold">Mobile Banner URL</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter URL for Mobile banner"
                value={webURL}
                onChange={(e) => setWebURL(e.target.value)}
                required
              />
            </div>

            {/* Save / Update button */}
            <div className="mt-4">
              <button
                type="button"
                className="btn btn-primary px-5"
                onClick={handleSave}
                disabled={loading}
              >
                {loading ? "Saving..." : id ? "UPDATE" : "SAVE"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default AddMobileBanner;
